var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-spacing",attrs:{"id":"invest"}},[_c('section-header',{attrs:{"title":_vm.$tc('invest.title')}}),_c('div',[_c('p',{staticClass:"section-spacing"},[_vm._v(" "+_vm._s(_vm.$tc("invest.intro"))+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }